<dx-box
    #propertyCurrentOwnersBox
    height="100%"
    width="100%"
    direction="col"
    [elementAttr]="{ id: 'propertyCurrentOwnersBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <div *ngIf="hasRecords" class="grid-container">
            <cc-data-grid-features
                #gridFeatures
                [stateConfig]="{ storageKey: 'CURRENT_OWNERS_SEARCH_GRID' }"
                [dataSource]="propertyCurrentOwners"
            >
                <dx-data-grid width="100%" height="100%" [dataSource]="propertyCurrentOwners">
                    <dxo-search-panel [text]="searchText"></dxo-search-panel>
                    <dxi-column dataField="tollFreeNumber" dataType="string" caption="Toll Free Number"></dxi-column>
                    <dxi-column
                        dataField="managementCompany"
                        dataType="string"
                        caption="Management Company"
                    ></dxi-column>
                    <dxi-column dataField="location" dataType="string" caption="Location"></dxi-column>
                    <dxi-column
                        dataField="community"
                        dataType="string"
                        caption="Community"
                        cellTemplate="communityTemplate"
                    ></dxi-column>
                    <dxi-column dataField="owner" dataType="string" caption="Owner"></dxi-column>
                    <dxi-column dataField="combinedOwner" dataType="string" caption="Combined Owner"></dxi-column>
                    <dxi-column
                        dataField="propertyAddress"
                        dataType="string"
                        cellTemplate="propertyAddressTemplate"
                        caption="Property Address"
                    ></dxi-column>
                    <dxi-column
                        dataField="accountNumber"
                        dataType="string"
                        cellTemplate="accountNumberTemplate"
                        caption="Account Number"
                    ></dxi-column>
                    <dxi-column
                        dataField="currentOwner"
                        dataType="boolean"
                        cellTemplate="currentOwnerTemplate"
                        caption="Current Owner"
                        [allowGrouping]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="ownerOccupied"
                        dataType="boolean"
                        cellTemplate="ownerOccupiedTemplate"
                        caption="Owner Occupied"
                        [allowGrouping]="false"
                    ></dxi-column>

                    <dxi-column dataField="block" dataType="string" caption="Block" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="buyerCloseDate"
                        dataType="string"
                        caption="Buyer Close Date"
                        [format]="dateFormat"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="cell" dataType="number" caption="Cell" [visible]="false"></dxi-column>
                    <dxi-column dataField="city" dataType="string" caption="City" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="communityId"
                        dataType="number"
                        caption="Community #"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="intacctCo"
                        dataType="string"
                        caption="Community ID"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="drvCollections"
                        dataType="boolean"
                        trueText="Yes"
                        falseText="No"
                        dataType="boolean"
                        caption="Referred Compliance"
                        cellTemplate="redflagCellTemplate"
                        [showEditorAlways]="false"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="email1" dataType="string" caption="Email1" [visible]="false"></dxi-column>
                    <dxi-column dataField="email2" dataType="string" caption="Email2" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="hasTenant"
                        dataType="boolean"
                        trueText="Yes"
                        falseText="No"
                        caption="Has Tenant"
                        cellTemplate="booleanCellTemplate"
                        [showEditorAlways]="false"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="inBankruptcy"
                        dataType="boolean"
                        trueText="Yes"
                        falseText="No"
                        caption="In Bankruptcy"
                        cellTemplate="redflagCellTemplate"
                        [showEditorAlways]="false"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="inCollections"
                        dataType="boolean"
                        trueText="Yes"
                        falseText="No"
                        caption="In Collections"
                        cellTemplate="redflagCellTemplate"
                        [showEditorAlways]="false"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="inForeclosure"
                        dataType="boolean"
                        trueText="Yes"
                        falseText="No"
                        caption="In Foreclosure"
                        cellTemplate="redflagCellTemplate"
                        [showEditorAlways]="false"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="lot" dataType="string" caption="Lot" [visible]="false"></dxi-column>
                    <dxi-column dataField="lotType" dataType="string" caption="Lot Type" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="mailingAddress"
                        dataType="string"
                        caption="Mailing Address"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="mailingAddress2"
                        dataType="string"
                        caption="Mailing Address2"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="mailingCity"
                        dataType="string"
                        caption="Mailing City"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="mailingState"
                        dataType="string"
                        caption="Mailing State"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="mailingCountry"
                        dataType="string"
                        caption="Mailing Country"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="mailingZip"
                        dataType="string"
                        caption="Mailing Zip"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="openBalanceUrl"
                        dataType="string"
                        caption="Open Balance"
                        cellTemplate="openBalanceTemplate"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="lastFirstName"
                        dataType="string"
                        caption="Owner Last, First Name"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="ownerType"
                        dataType="string"
                        caption="Owner Type"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="ownerId" dataType="number" caption="Owner ID" [visible]="false"></dxi-column>
                    <dxi-column dataField="phase" dataType="string" caption="Phase" [visible]="false"></dxi-column>
                    <dxi-column dataField="phone" dataType="number" caption="Phone" [visible]="false"></dxi-column>
                    <dxi-column dataField="priorId" dataType="number" caption="Prior ID" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="propertyCSZ"
                        dataType="string"
                        caption="Property CSZ"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="propertyType"
                        dataType="string"
                        caption="Property Type"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="propertyId"
                        dataType="number"
                        caption="Property ID"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="section" dataType="string" caption="Section" [visible]="false"></dxi-column>
                    <dxi-column dataField="state" dataType="string" caption="State" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="statementUrl"
                        dataType="string"
                        caption="Statement"
                        cellTemplate="statementTemplate"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="streetName"
                        dataType="string"
                        caption="Street Name"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="streetNumber"
                        dataType="string"
                        caption="Street Number"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="zip" dataType="string" caption="Zip" [visible]="false"></dxi-column>

                    <div *dxTemplate="let cell of 'currentOwnerTemplate'">
                        <i [ngClass]="getCheckMarkIcon(cell.data.currentOwner)"></i>
                    </div>

                    <div *dxTemplate="let cell of 'ownerOccupiedTemplate'">
                        <i [ngClass]="getCheckMarkIcon(cell.data.ownerOccupied)"></i>
                    </div>

                    <div *dxTemplate="let cell of 'redflagCellTemplate'">
                        <i *ngIf="cell.value" [ngClass]="iconFlag"></i>
                    </div>

                    <div *dxTemplate="let cell of 'booleanCellTemplate'">
                        <i *ngIf="cell.value" [ngClass]="iconCheck"></i>
                    </div>

                    <div *dxTemplate="let cell of 'propertyAddressTemplate'">
                        <app-property-community-link
                            [communityId]="cell.data.communityId"
                            [customerId]="cell.data.accountNumber"
                            [displayText]="cell.value"
                            (onClick)="setContextDetails(cell.data)"
                        ></app-property-community-link>
                    </div>

                    <div *dxTemplate="let cell of 'communityTemplate'">
                        <app-property-community-link
                            [communityId]="cell.data.communityId"
                            [displayText]="cell.value"
                            (onClick)="setContextDetails(cell.data)"
                        ></app-property-community-link>
                    </div>

                    <div *dxTemplate="let cell of 'accountNumberTemplate'">
                        <app-property-community-link
                            [communityId]="cell.data.communityId"
                            [customerId]="cell.data.accountNumber"
                            [displayText]="cell.value"
                            (onClick)="setContextDetails(cell.data)"
                        ></app-property-community-link>
                    </div>

                    <div *dxTemplate="let cell of 'openBalanceTemplate'">
                        <app-hyperlink-creator
                            mode="hyperlinkOnly"
                            [displayText]="cell.value"
                            (onLinkClick)="onOpenBalanceClick(cell.data)"
                        ></app-hyperlink-creator>
                    </div>

                    <div *dxTemplate="let cell of 'statementTemplate'">
                        <app-hyperlink-creator
                            mode="hyperlinkOnly"
                            [displayText]="cell.value"
                            (onLinkClick)="onStatementClick(cell.data)"
                        ></app-hyperlink-creator>
                    </div>

                    <dxo-summary>
                        <dxi-group-item
                            column="accountNumber"
                            summaryType="count"
                            displayFormat="Count = {0}"
                        ></dxi-group-item>
                    </dxo-summary>
                </dx-data-grid>
            </cc-data-grid-features>
        </div>
        <div *ngIf="!hasRecords">{{ noRecordMessage }}</div>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#propertyCurrentOwnersBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
